import requestv2 from "~/utils/http-v2";

const pushApi = {
	publicKey : async () => {
		const url = 'v2/push/public-key';
		return await requestv2.get(url);
	},
	subscribe : async (params) => {
		const url = 'v2/push/subscribe';
		return await requestv2.post(url, params);
	},
	unsubscribe : async (params) => {
		const url = 'v2/push/unsubscribe';
		return await requestv2.post(url, params);
	},
};

export default pushApi;
